// import React, { useEffect, useRef } from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import { Provider } from "react-redux";
// import { persistor, store } from "./app/store";
// import { PersistGate } from "redux-persist/integration/react";
// import { WalletProvider } from "./context/walletContext";
// import { ToastContainer } from "react-toastify";
// import { AuthProvider } from "./context/authContext";
// import { LoaderProvider, useLoader } from "./context/loaderContext";
// import { setLoader } from "./api/axiosInstance";
// import GlobalLoader from "./components/Loader/GlobalLoader";
// import { BankListProvidor } from "./context/authBankContext";
// import { NotificationProvider } from "./context/NotifyContext";


// const LoaderBridge = () => {
//   const { loading, setLoading } = useLoader();
//   const initialized = useRef(false);
//   useEffect(() => {
//     if (!initialized.current) {
//       setLoader(setLoading); // ✅ only once
//       initialized.current = true;
//     }
//   }, [setLoading]);
//   return loading ? <GlobalLoader /> : null;
// };
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <Provider store={store}>
//     <PersistGate loading={null} persistor={persistor}>
//       <BankListProvidor>
//       <LoaderProvider>
//               <NotificationProvider>

//         <AuthProvider>
//           <LoaderBridge />
//           <WalletProvider>
//             <App />
//             <ToastContainer
//             />
//           </WalletProvider>
//         </AuthProvider>
//             </NotificationProvider>
//       </LoaderProvider>
//       </BankListProvidor>
//     </PersistGate>
//   </Provider>
// );



import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./designSystem/designSystem.css";
import App from "./App";
import { Provider } from "react-redux";
import { persistor, store } from "./app/store";
import { PersistGate } from "redux-persist/integration/react";
import { WalletProvider } from "./context/walletContext";
import { ToastContainer } from "react-toastify";
import { AuthProvider } from "./context/authContext";
import { LoaderProvider, useLoader } from "./context/loaderContext";
import { setLoader } from "./api/axiosInstance";
import GlobalLoader from "./components/Loader/GlobalLoader";
import { BankListProvidor } from "./context/authBankContext";
import { NotificationProvider } from "./context/NotifyContext";
import { ThemeProvider as MuiThemeProvider, CssBaseline } from "@mui/material";
import { getTheme } from "./theme";
import { ThemeProviderCustom, useThemeMode } from "./context/ThemeContext";
import { BrandingProvider, useBranding } from "./context/BrandingContext";

const LoaderBridge = () => {
  const { loading, setLoading } = useLoader();
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current) {
      setLoader(setLoading);
      initialized.current = true;
    }
  }, [setLoading]);

  return loading ? <GlobalLoader /> : null;
};

const RootApp = () => {
  const { mode } = useThemeMode();
  const { settings } = useBranding();
  const theme = React.useMemo(
    () => getTheme(mode, settings || {}),
    [mode, settings]
  );

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BankListProvidor>
            <LoaderProvider>
              <NotificationProvider>
                <AuthProvider>
                  <LoaderBridge />
                  <WalletProvider>
                    <App />
                    <ToastContainer
                      position={settings?.toastPosition || "top-right"}
                      theme={mode === "dark" ? "dark" : "light"}
                      autoClose={3000}
                    />
                  </WalletProvider>
                </AuthProvider>
              </NotificationProvider>
            </LoaderProvider>
          </BankListProvidor>
        </PersistGate>
      </Provider>
    </MuiThemeProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <ThemeProviderCustom>
    <BrandingProvider>
      <RootApp />
    </BrandingProvider>
  </ThemeProviderCustom>
);
